module.exports = __webpack_public_path__ + "static/ogp-caea1649f87d1bbc8e710983ad1de0cc.png";